/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {ProgramAutoCompleteFieldEditor} from "../ServiceDrivenEditors";

export function ProgramFieldEditor(props) {

	const orgId = props?.CustomData?.organizationId || props.RootData?.organizationId;

	return <ProgramAutoCompleteFieldEditor
		{...props}
		CustomData={{
			additionalSearchParams: {orgId},
			filter: function (values, selectedItem) {
				return values.filter(x => x.parentProgramId !== null);
			},
			...props.CustomData,
		}}
	/>;
}